module.exports = __webpack_public_path__ + "img/资产化.bd906562.png";